import { Api } from '@monorepo/shared/apiClient';
import {
  invalidateViewCache,
  ViewCacheEvents,
} from '@monorepo/shared/cacheRegisters/data2/viewCacheRegister';
import { MutationConfig, useMutation } from 'react-query';
import { setCache as setViewCache } from './useView';

type useViewCopyParams = {
  config?: MutationConfig<Api.CopyViewResponse, Api.ErrorResponse>;
};

export const useViewCopy = (params?: useViewCopyParams) =>
  useMutation(Api.copyView, {
    ...params?.config,
    onSuccess: async (createdView, mutationFuncParams) => {
      const { organizationId } = mutationFuncParams;

      // Set cache for that single view/report
      const keyParams = {
        organizationId,
        projectId: createdView.projectId,
        viewId: createdView.id,
      };
      setViewCache(keyParams, createdView);

      // Invalidate any cache that includes info about views
      invalidateViewCache(ViewCacheEvents.CREATE, keyParams);

      return params?.config?.onSuccess?.(createdView, mutationFuncParams);
    },
  });
